import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Slider from "react-slick"

import Seminar1 from "../../../static/space/studycommon/study-seminar1.jpg"
import Seminar2 from "../../../static/space/studycommon/study-seminar2.jpg"
import Seminar3 from "../../../static/space/studycommon/study-seminar3.jpg"

const Container = styled.div`
  padding: 1vw 0 7vw;

  .title-slide {
    margin: 3vw 0 2vw;
  }
  .seminar-slide-first img {
    width: 60vw;
    height: 30vw;
    margin-left: auto;
    margin-right: auto;
  }
  .seminar-slide-first {
    height: 30vw;
  }

  .seminar-slide-second {
    height: 7.5vw;
  }

  .seminar-slide-second img {
    width: 14.5vw;
    margin: 0 auto;
    height: 7.5vw;
  }

  .slick-slider {
    width: 60.4vw;
    margin: 3vw auto;
  }
  .slick-next,
  .slick-prev,
  .slick-next:before,
  .slick-prev:before {
    display: none;
  }
  .hide-480 {
    display: block;
  }

  .show-480 {
    display: none;
  }

  @media screen and (max-width: 480px) {
    .hide-480 {
      display: none;
    }

    .show-480 {
      display: block;
    }

    img.slide-img-480 {
      width: 80vw;
      margin: 0 auto 2.5vw;
      display: block;
    }
  }
`

const space_seminar = () => {
  const [nav1, setNav1] = useState(null)
  const [nav2, setNav2] = useState(null)
  let slider1: any = []
  let slider2: any = []

  useEffect(() => {
    setNav1(slider1)
    setNav2(slider2)
  }, [slider1, slider2])

  return (
    <Container>
      <link
        rel="stylesheet"
        type="text/css"
        charSet="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />

      <div className="show-480">
        <img className="slide-img-480" src={Seminar1} alt="세미나실1" />

        <img className="slide-img-480" src={Seminar2} alt="세미나실2" />

        <img className="slide-img-480" src={Seminar3} alt="세미나실3" />
      </div>
      <div>
        <Slider
          className="title-slide hide-480"
          asNavFor={nav2}
          ref={slider => (slider1 = slider)}
        >
          <div className="seminar-slide-first">
            <img src={Seminar1} alt="세미나실1" />
          </div>
          <div className="seminar-slide-first">
            <img src={Seminar2} alt="세미나실2" />
          </div>
          <div className="seminar-slide-first">
            <img src={Seminar3} alt="세미나실3" />
          </div>
        </Slider>
        <Slider
          className="same-title-slide hide-480"
          asNavFor={nav1}
          ref={slider => (slider2 = slider)}
          slidesToShow={4}
          swipeToSlide={true}
          focusOnSelect={true}
        >
          <div className="seminar-slide-second">
            <img src={Seminar1} alt="세미나실1" />
          </div>
          <div className="seminar-slide-second">
            <img src={Seminar2} alt="세미나실2" />
          </div>
          <div className="seminar-slide-second">
            <img src={Seminar3} alt="세미나실3" />
          </div>
          <div className="seminar-slide-second"></div>
        </Slider>
      </div>
    </Container>
  )
}

export default space_seminar
